export const COUNTIES_MANUKAU = "Counties Manukau";
export const WAITEMATA = "Waitemata";
export const CME_APP_ID = "0ED4A6FB-DE60-4020-8E02-E82EBEF1E3AA";
export const REQUEST_FORM_DEFINITION_ID =
	"0C36599D-2330-41E9-9CDB-809EA5248F32";
export const CPE_FORM_DEFINITION_ID = "05F234C8-11F7-44D1-9E18-C1770D489D40";
export const CPD_COURSE_CLAIM_FORM_DEFINITION_ID =
	"1986AEB4-1BB4-4CA8-9B4D-A932DC65F15C";

export const isCpeForm = (formDefinitionId) =>
	[CPE_FORM_DEFINITION_ID, CPD_COURSE_CLAIM_FORM_DEFINITION_ID].includes(
		formDefinitionId?.toUpperCase()
	);

export const CME_CONFIG = {
	WDHB: {
		//IT
		ItClaimLimitWithoutPreapproval: 1000,
		ItClaimLineLimit: 999999,
		ClinicalEquipmentEnabled: true,
		ApprovalBeforeCmoLimit: 10000,
		//WRE
		WreEnabled: false,
		//Workflows
		WorkflowEnableAdd: false,
		//CPD
		CpdEnabled: true,
		//General
		CmeSupportEmail: "CMEQueries@waitematadhb.govt.nz",
		DisableCmeXMonthsBeforeEndDate: 0,
		AllowCancellingRequests: true,
		FinanceApproverIfOverLimit: true,
		Admin: {
			EnablePayrollGroup: false,
			RequireUserId: true,
		},
	},
	"Counties Manukau": {
		//IT
		ItClaimLimitWithoutPreapproval: 450,
		ItClaimLineLimit: 5000,
		ClinicalEquipmentEnabled: false,
		ApprovalBeforeCmoLimit: 999999,
		//WRE
		WreEnabled: true,
		//Workflows
		WorkflowEnableAdd: true,
		//CPD
		CpdEnabled: true,
		//General
		CmeSupportEmail: "CME.WRE.Claims@middlemore.co.nz",
		DisableCmeXMonthsBeforeEndDate: 3,
		AllowCancellingRequests: false,
		FinanceApproverIfOverLimit: false,
		Admin: {
			EnablePayrollGroup: false,
			RequireUserId: true,
		},
	},
	Northland: {
		//IT
		ItClaimLimitWithoutPreapproval: 1000,
		ItClaimLineLimit: 999999,
		ClinicalEquipmentEnabled: true,
		ApprovalBeforeCmoLimit: 10000,
		//WRE
		WreEnabled: false,
		//Workflows
		WorkflowEnableAdd: false,
		//CPD
		CpdEnabled: true,
		//General
		CmeSupportEmail: "SMOCMENorthland@northlanddhb.org.nz",
		DisableCmeXMonthsBeforeEndDate: 0,
		AllowCancellingRequests: true,
		FinanceApproverIfOverLimit: false,
		Admin: {
			EnablePayrollGroup: true,
			RequireUserId: false,
		},
	},
};
